<template>
    <div id="myHelp" :class="maximize">
        
        <!-- Include a header DIV with the same name as the draggable DIV, followed by "header" -->
        <div id="myHelpheader">
            <div>
                <i class="las la-braille"></i> 
                <i class="las la-times pointer" @click="closeContact()"></i>
                <i class="las pointer" :class="maximizeIcon" @click="maxMin()"></i>
            </div>
            <div><span>Ficha del Consultante</span></div>
        </div>
        <div class="content-help" :class="full">
            <div class="overflow-auto">
                <div class="content-help-info"> 
                    <div class="">           
                        <records showBackground="d-flex justify-content-center align-items-center clients-container" v-if="refId !=''" displayInitialText="none" :showContacts="false" :openUser="refId" :classClient="'clients-full'" :showChat="false"></records>
                    </div> 
                </div>
            </div>

            
        </div>
    </div>
</template>
<script>
import records from '@/components/clients/records.vue'
export default {
    props: ['openHelp', 'refId', 'type', 'userName', 'mode', 'publishRef'],
    data(){
        return{  
            title: '',

            full: 'full',
            maximize: '',
            maximizeIcon: 'la-expand',
            pageCount: 1,
            isLoading: true,
            scales: 1, 
            
            doNotShow: false,
            disabledNext: true,
            disabledPrev: true,
  
        }
    },
    components: {
        records,
        
    },
    mounted: function () { 
        this.dragElement(document.getElementById("myHelp")); 
    },  
    methods: {
        closeContact(){
            this.showModal = false;
            this.$root.closeContact();
        }, 
        maxMin(){
            if(this.maximize == ''){
                this.maximize = 'maximize';
                this.maximizeIcon = 'la-compress';     
            }else{
                this.maximize = '';
                this.maximizeIcon = 'la-expand';
            }
        },
        dragElement(elmnt) {
                var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
                if (document.getElementById(elmnt.id + "header")) {
                    // if present, the header is where you move the DIV from:
                    document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
                } else {
                    // otherwise, move the DIV from anywhere inside the DIV:
                    elmnt.onmousedown = dragMouseDown;
                }
                function dragMouseDown(e) {
                    e = e || window.event;
                    e.preventDefault();
                    // get the mouse cursor position at startup:
                    pos3 = e.clientX;
                    pos4 = e.clientY;
                    document.onmouseup = closeDragElement;
                    // call a function whenever the cursor moves:
                    document.onmousemove = elementDrag;
                }
                function elementDrag(e) {
                    e = e || window.event;
                    e.preventDefault();
                    // calculate the new cursor position:
                    pos1 = pos3 - e.clientX;
                    pos2 = pos4 - e.clientY;
                    pos3 = e.clientX;
                    pos4 = e.clientY;
                    // set the element's new position:
                    if((elmnt.offsetTop - pos2) < 0){
                        elmnt.style.top =  "0px";
                    }else if((elmnt.offsetTop - pos2) > (window.innerHeight - 100)){
                       elmnt.style.top = (window.innerHeight - 100) + "px";
                    }else{
                        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
                    }
                    if((elmnt.offsetLeft - pos1) > (window.innerWidth - 100)){
                        elmnt.style.left = (window.innerWidth - 100) + "px";
                    }else if((elmnt.offsetLeft - pos1) < -880){

                    }else{
                        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
                    }
                    
                }
                function closeDragElement() {
                    // stop moving when mouse button is released:
                    document.onmouseup = null;
                    document.onmousemove = null;
                }
           
        },
    
    }
}
</script>
<style scoped>
#myHelpheader {
    border-radius: 7px 7px 0 0;
    padding: 10px;
    cursor: move;
    z-index: 10;
    background-color: #004193;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.content-help.full .content-help-info {
    width: 100%;
    display: block;
    position: absolute;
    overflow: auto;
    height: -webkit-fill-available;
    text-align: left;
}

</style>